import { Division, Skeleton } from "@ir/ui";

const SkeletonCell = ({ height = 10, width = 120 }: { height?: number; width?: number }) => {
    return (
      <Division className="px-2">
        <Skeleton height={height} width={width} animation="wave" variant="rounded" />
      </Division>
    );
  };

export default SkeletonCell;